import { api } from "./../../config/api";

const basePath = "cliente-empresas";

export const getEmpresas = (options) => {
  const { client_id, cancelToken } = options;

  const config = {};

  if (cancelToken) {
    config.cancelToken = cancelToken;
  }

  return api.get(`${basePath}/${client_id}`, config);
};

export const uploadArquivo = (options) => {
  const { cliente_id, empresa_id, tipo, file, cancelToken } = options;

  const formData = new FormData();
  formData.append("arquivo", file);
  formData.append("tipo", tipo);
  formData.append("empresa_id", empresa_id);

  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  if (cancelToken) {
    config.cancelToken = cancelToken;
  }

  return api.post(`${basePath}/${cliente_id}`, formData, config);
};
